import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Dossie } from '../models/dossie.model';
import { DossieRepository, DOSSIER_REPOSITORY } from '../repositories/dossie.repository';
import { DossieRequest } from '../models/dossie-request.model';

@Injectable({
  providedIn: 'root'
})
export class CriarDossieUseCase {
  constructor(
    @Inject(DOSSIER_REPOSITORY) private readonly repository: DossieRepository
  ) {}

  execute(payload: DossieRequest): Observable<Dossie> {
    return this.repository.criarDossie(payload);
  }
}
